function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16 24a8 8 0 110-16 8 8 0 010 16z",
  fill: "#D4E1EE"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.699 19.261l4.819-4.82a.961.961 0 00-1.359-1.36l-4.14 4.141-2.178-2.179a.962.962 0 00-1.36 1.36l2.858 2.858a.958.958 0 001.36 0z",
  fill: "#fff"
});

var SvgIconUnfinished = function SvgIconUnfinished(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDI0QzExLjU4MTYgMjQgOCAyMC40MTg0IDggMTZDOCAxMS41ODE2IDExLjU4MTYgOCAxNiA4QzIwLjQxODQgOCAyNCAxMS41ODE2IDI0IDE2QzI0IDIwLjQxODQgMjAuNDE4NCAyNCAxNiAyNFoiIGZpbGw9IiNENEUxRUUiLz4KPHBhdGggZD0iTTE1LjY5ODggMTkuMjYxM0wyMC41MTc4IDE0LjQ0MDdDMjAuODk0NyAxNC4wNjUyIDIwLjg5MzcgMTMuNDU2NiAyMC41MTc4IDEzLjA4MTJDMjAuMTQzMyAxMi43MDYyIDE5LjUzMzggMTIuNzA2MiAxOS4xNTg5IDEzLjA4MTJMMTUuMDE5MSAxNy4yMjIxTDEyLjg0MTEgMTUuMDQzNUMxMi40NjU2IDE0LjY2ODUgMTEuODU2NiAxNC42Njg1IDExLjQ4MTYgMTUuMDQzNUMxMS4xMDYyIDE1LjQxODkgMTEuMTA2MiAxNi4wMjg1IDExLjQ4MTYgMTYuNDAyOUwxNC4zMzk0IDE5LjI2MTNDMTQuNTI3MyAxOS40NDkyIDE0Ljc3MyAxOS41NDMgMTUuMDE5MSAxOS41NDNDMTUuMjY1MiAxOS41NDMgMTUuNTEwOCAxOS40NDkyIDE1LjY5ODggMTkuMjYxM1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgIconUnfinished as ReactComponent };